export var CheckboxState;
(function (CheckboxState) {
    CheckboxState["UNCHECKED"] = "UNCHECKED";
    CheckboxState["CHECKED"] = "CHECKED";
    CheckboxState["INDETERMINATE"] = "INDETERMINATE";
})(CheckboxState || (CheckboxState = {}));
